export default "__VITE_ASSET__9p44rghe__"